export const SAVE_USER_ACCESS_MUTATION = `
  mutation (
    $username: String!
    $startDate: String
    $reference: String
    $effectiveYear: Int!
    $access: [UserMappingBreakdown]
  ) {
    createUserMapping(
      userMapping: {
        Username: $username
        effectiveYear: $effectiveYear
        startDate: $startDate
        reference: $reference
        Access: $access
      }
    ) {
      data {
        Username
        mappings {
          endDate
          startDate
          reference
          insertedDate
          isCurrent
          access {
            element1Id
            element2Id
            element3Id
            element4Id
          }
        }
        id
      }
      error {
        statusCode
        message
        code
      }
    }
  }
`
